import ICON_MORE_LIGHT from '../../../../public/static/v4/home-header/icon-more-light.svg';
import ICON_MORE from '../../../../public/static/v4/home-header/icon-more.svg';
import ICON_SEARCH_LIGHT from '../../../../public/static/v4/home-header/icon-search-light.svg';
import ICON_SEARCH from '../../../../public/static/v4/home-header/icon-search.svg';
import Anchor from '../../../common/component/Anchor';
import RedDot from '../../../common/component/RedDot';
import {Page} from '../../../common/constant/page';
import useTheme from '../../../common/hook/useTheme';
import {routeTo} from '../../../common/util/PageRouter';
import {sendHomeEvent} from '../tracking';

interface IProps {
  hasNewMore: boolean;
}

export default function HomeHeaderRightV4({hasNewMore}: IProps) {
  const {isLightMode} = useTheme();
  return (
    <div className="ml-auto">
      <Anchor
        className="mr-20"
        pageInfo={{page: Page.Search}}
        display="inline"
        onClick={() => {
          sendHomeEvent({
            actionName: 'search_icon',
            action: 'click',
            customProps: {event_layer: 'header'},
          });
          routeTo({page: Page.Search});
        }}
      >
        <img src={isLightMode ? ICON_SEARCH_LIGHT : ICON_SEARCH} alt="search" />
      </Anchor>
      <Anchor
        className={hasNewMore ? 'relative' : undefined}
        pageInfo={{page: Page.More}}
        display="inline"
        onClick={() => {
          sendHomeEvent({
            actionName: 'sidemenu_icon',
            action: 'click',
            customProps: {event_layer: 'header'},
          });
          routeTo({page: Page.More});
        }}
      >
        <img src={isLightMode ? ICON_MORE_LIGHT : ICON_MORE} alt="more" />
        {hasNewMore && <RedDot className="right-0 -top-2" />}
      </Anchor>
    </div>
  );
}
